/**
 * signposting.ts — the R31 crisis signposting lines.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: C1.1 (patient journey).
 *
 * WHY: R31 is absolute — any mental-health-flagged stop MUST show crisis
 * signposting and route to a human. The server sends its vetted lines on the
 * evaluation result (`signposting.lines`), and the stop screen renders those
 * verbatim; this local set is the fail-safe so an mhRisk stop can NEVER
 * render without the three services, even if a payload arrives without them.
 */

/** Fallback crisis lines (999 · Samaritans 116 123 · NHS 111). */
export const CRISIS_LINES: readonly string[] = [
  'If you or someone else is in immediate danger, call 999 now.',
  'Samaritans — call 116 123, free, day or night.',
  'NHS 111 — for urgent mental health support, call 111 and select the mental health option.',
];
